import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

// Displays a live countdown to the test attempt deadline.
// The server is the deadline authority — this is display-only.
// At zero, posts to the finalize endpoint so the server can grade.
export default class extends Controller {
  static targets = ["display"];
  static values = {
    expiresAt: String,
    finalizeUrl: String,
  };

  connect() {
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const now = Date.now();
    const expiry = new Date(this.expiresAtValue).getTime();
    const remaining = Math.max(0, Math.floor((expiry - now) / 1000));

    if (this.hasDisplayTarget) {
      this.displayTarget.textContent = this.#format(remaining);
    }

    if (remaining <= 0) {
      clearInterval(this.timer);
      this.#autoFinalize();
    }
  }

  #format(totalSeconds) {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
  }

  #autoFinalize() {
    if (this.finalized) return;
    this.finalized = true;

    const token =
      document.querySelector("meta[name=csrf-token]")?.content || "";

    fetch(this.finalizeUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        Accept: "text/html",
      },
    }).then((response) => {
      if (response.redirected) {
        Turbo.visit(response.url);
      } else {
        Turbo.visit(this.finalizeUrlValue);
      }
    });
  }
}
